import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <section className="hero">
        <h1 className="hero-title">
          <span className="title-word">Craft</span>
          <span className="title-word">Your</span>
          <span className="title-word gradient-text">Digital Soul</span>
        </h1>
        <p className="tagline">
          We architect immersive digital experiences that transcend pixels.
          Blending cutting-edge tech with visionary design to create websites that don't just exist—they <strong>resonate</strong>.
        </p>

        <div className="stats-grid">
          <div className="stat-card glass">
            <div className="stat-num">30+</div>
            <div className="stat-label">Projects Launched</div>
          </div>
          <div className="stat-card glass">
            <div className="stat-num">100%</div>
            <div className="stat-label">Client Delight</div>
          </div>
          <div className="stat-card glass">
            <div className="stat-num">∞</div>
            <div className="stat-label">Creative Possibilities</div>
          </div>
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">
          <span className="gradient-text">Featured Work</span>
        </h2>

        <div className="projects">
          <a href="https://www.gayatri.homes/" target="_blank" rel="noopener noreferrer" className="project glass">
            <div className="project-preview">
              <div className="project-glow" style={{ background: 'linear-gradient(135deg, #ff006e 0%, #8338ec 100%)' }}></div>
              <img 
                src="/images/gayatri-homes.png" 
                alt="Gayatri Homes" 
                className="project-screenshot"
              />
            </div>
            <div className="project-info">
              <h3 className="project-name">Gayatri Homes</h3>
              <p className="project-desc">
                A seamless blend of modern architecture and spiritual navigation for 2026.
              </p>
              <div className="tech-stack">
                <span className="tech">React</span>
                <span className="tech">Immersive UI</span>
                <span className="tech">API</span>
              </div>
            </div>
          </a>

          <a href="https://www.galacticcompass.com/" target="_blank" rel="noopener noreferrer" className="project glass">
            <div className="project-preview">
              <div className="project-glow" style={{ background: 'linear-gradient(135deg, #3a86ff 0%, #06ffa5 100%)' }}></div>
              <img 
                src="/images/galactic-compass.png" 
                alt="Galactic Compass" 
                className="project-screenshot"
              />
            </div>
            <div className="project-info">
              <h3 className="project-name">Galactic Compass</h3>
              <p className="project-desc">
              "Anima"—an AI-powered ethereal journey through digital cosmos. Built on advanced RAG (Retrieval-Augmented Generation) architecture, 
              this experience pushes boundaries with fluid animations, 3D interactions, and intelligent storytelling that transcends traditional web design
              </p>
              <div className="tech-stack">
                <span className="tech">Three.js</span>
                <span className="tech">GSAP</span>
                <span className="tech">WebGL</span>
              </div>
            </div>
          </a>

          <a href="https://www.lightbeforedusk.com/" target="_blank" rel="noopener noreferrer" className="project glass">
            <div className="project-preview">
              <div className="project-glow" style={{ background: 'linear-gradient(135deg, #ffbe0b 0%, #fb5607 100%)' }}></div>
              <img 
                src="/images/light-before-dusk.png" 
                alt="Light Before Dusk" 
                className="project-screenshot"
              />
            </div>
            <div className="project-info">
              <h3 className="project-name">Light Before Dusk</h3>
              <p className="project-desc">
                Elite portfolio for a Software Engineer. Minimalist elegance meets
                technical prowess through performant React architecture and thoughtful interactions.
              </p>
              <div className="tech-stack">
                <span className="tech">React</span>
                <span className="tech">Portfolio</span>
                <span className="tech">Motion</span>
                <span className="tech">Professional</span>
              </div>
            </div>
          </a>
        </div>
      </section>

      <section className="section" style={{ background: 'rgba(255,255,255,0.01)' }}>
        <h2 className="section-title">Why We're <span className="gradient-text">Different</span></h2>

        <div className="features-grid">
          <div className="feature glass">
            <h3 className="feature-title">Hyper-Optimized</h3>
            <p className="feature-desc">Lightning-fast load times, 60fps animations, edge-first architecture. Performance isn't a feature—it's our foundation.</p>
          </div>

          <div className="feature glass">
            <h3 className="feature-title">Bespoke Design Systems</h3>
            <p className="feature-desc">Custom-crafted from pixels up. No templates, no shortcuts. Every element designed specifically for your brand DNA.</p>
          </div>

          <div className="feature glass">
            <h3 className="feature-title">Cutting-Edge Tech</h3>
            <p className="feature-desc">WebGL, Three.js, AI integration, micro-interactions. We build with tomorrow's stack, today.</p>
          </div>

          <div className="feature glass">
            <h3 className="feature-title">Fluid Responsiveness</h3>
            <p className="feature-desc">Seamless across all devices. From mobile to 8K displays, your experience adapts fluidly and beautifully.</p>
          </div>

          <div className="feature glass">
            <h3 className="feature-title">SEO Excellence</h3>
            <p className="feature-desc">Built for discovery. Semantic HTML, optimized Core Web Vitals, structured data. We engineer visibility.</p>
          </div>

          <div className="feature glass">
            <h3 className="feature-title">Enterprise Security</h3>
            <p className="feature-desc">Bank-grade security, 99.99% uptime, automated backups. Your digital presence, fortified and reliable.</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h1 className="cta-title">
          Ready to <span className="gradient-text">Transcend</span>?
        </h1>
        <p className="cta-subtitle">
          Your brand deserves a digital presence that commands attention. Let's build something extraordinary together.
        </p>
        <Link to="/contact" className="cta-button">Let's Create Magic</Link>
      </section>
    </div>
  );
};

export default Home;
